module.exports = __webpack_public_path__ + "static/media/alert.2fac2d2f.mp3";